import { render } from "./Syouhinedit.vue?vue&type=template&id=1a5e6562&scoped=true&ts=true"
import script from "./Syouhinedit.vue?vue&type=script&lang=ts"
export * from "./Syouhinedit.vue?vue&type=script&lang=ts"

import "./Syouhinedit.vue?vue&type=style&index=0&id=1a5e6562&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src1530414395/src/mediadept-site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a5e6562"]])

export default __exports__